import React from "react";
import Popup from "reactjs-popup";
import Button from "@material-ui/core/Button";
import {CircularProgress} from "@material-ui/core";
import requests from "../constants/requests";
import {toast} from "react-toastify";

class DeletePlanPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDeleting: false
        }
        this.onDelete = this.onDelete.bind(this);
    }

    onDelete() {
        this.setState({ isDeleting: true })
        // delete this plan
        fetch(requests.DELETE_PLAN(this.props.planId), {
            method: 'POST',
            headers: requests.HEADER(),
            body: JSON.stringify({
                token: this.props.token
            })
        }).then((res) => {
            res.json().then((response) => {
                if(!response.isTokenValid) {
                    this.props.onLogout();
                }
                if(response.didRemoveSucceed) {
                    toast("Plan was deleted!")
                    this.props.onDeletePlan(this.props.planId);
                    this.props.closePopup();
                } else {
                    toast("Deleting plan failed! " + response.errMsg);
                    this.props.closePopup();
                }
            }).catch((err) => {
                toast("Deleting plan failed! Unknown error!");
                console.log(err);
                console.log("Parsing response body failed.");
                this.props.closePopup();
            })
        }).catch((err) => {
            toast("Deleting plan failed! Unknown error!");
            console.log(err);
            console.log("Deleting plan failed!");
            this.props.closePopup();
        })
    }

    render() {
        return (
            <Popup
                open={ true }
                onClose={ this.props.closePopup }
                closeOnDocumentClick
            >
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center',
                    marginTop: 30 }}>
                    <div>Are you sure you want to delete this plan?</div>
                    <div style={{ display: 'flex', flexDirection: 'row'}}>
                        <Button
                            style={{ margin: 20 }} variant={ 'contained' } color={ 'secondary' }
                            onClick={ this.onDelete } disabled={ this.state.isDeleting }
                        >
                            {
                                this.state.isDeleting
                                    ? <CircularProgress size={24} />
                                    : "Delete"
                            }
                        </Button>
                        <Button
                            style={{ margin: 20 }} variant={ 'contained' } onClick={ this.props.closePopup }
                        >Cancel</Button>
                    </div>
                </div>
            </Popup>
        )
    }
}

export default DeletePlanPopup;